import { forwardRef } from 'react';
import { Box, BoxProps } from 'theme-ui';

const Instruction = forwardRef<HTMLInputElement, BoxProps>(({ children, className, ...props }: BoxProps, ref) => {
  return (
    <Box
      ref={ref}
      className={className}
      sx={{
        fontStyle: 'italic',
        fontSize: '0.85em',
        color: '#9b94b2'
      }}
      mb={1}
      mt={1}
      {...props}
    >
      {children}
    </Box>
  )
});

export default Instruction;
